import { action, makeObservable, observable, reaction } from 'mobx'
import moment from 'moment'
import StoragesStore from '../../../stores/StoragesStore'
import FormStore from '../../../utils/stores/FormStore'
import { getComp } from '../../../utils/utils/DI'

export const initParamsState = {
  statuses: [],
  creationDateFrom: null,
  creationDateTo: null,
  closeDateFrom: null,
  closeDateTo: null,
  status: '',
  dealerId: '',
  dealerIds: [],
  reportId: '',
  year: '',
  month: '',
  shelvs: '',
  boxes: [],
  IsDealerSenderOnly: [],
  financialSourceIds: [],
}

const validateData = {
  status: { required: true },
}

class ServiceReportsFilterStore extends FormStore {
  dealersStore: any
  data: any = initParamsState
  param: any
  constructor() {
    super({
      initState: initParamsState,
      validateData,
    })
    this.dateNames = [
      ['creationDateFrom', 'creationDateTo'],
      ['closeDateFrom', 'closeDateTo'],
    ]
    this.dealersStore = getComp('DealersStore')
    makeObservable(this, {
      isHighlighted: observable,
      data: observable,
      makeHighlightTrue: action,
      makeHighlightFalse: action,
    })
    reaction(
      () => this.data?.shelvs,
      () => {
        this.data.boxes = []
      },
    )
  }

  getBoxesFromShelv = () => {
    const { storages } = StoragesStore
    const shelv = storages[0]?.childs.find(
      (shelv: any) => shelv.id === this.data?.['shelvs'],
    )
    if (shelv && shelv.childs) {
      return shelv.childs.map((box: any) => ({
        key: box.name,
        value: box.id,
      }))
    } else {
      return []
    }
  }

  isHighlighted = false

  makeHighlightTrue = () => {
    if (this.data?.id !== '') {
      return
    }
    this.isHighlighted = true
  }

  makeHighlightFalse = () => (this.isHighlighted = false)

  clear = () => {
    this.setData(initParamsState)
    this.makeHighlightFalse()
    this.param = null
    this.clearSelectedFilters()
  }

  makeParamCopy = (param: any) => {
    this.param = param
  }

  getParamCopy = () => this.param

  getParams = () => {
    const param = {} as Record<string, any>
    for (const key in this.data) {
      if (!!this.data[key]) {
        switch (key) {
          case 'creationDateFrom':
          case 'creationDateTo':
          case 'closeDateFrom':
          case 'closeDateTo':
            if (key.includes('From')) {
              param[key] = this.data[key].format()
            } else {
              param[key] = this.data[key].endOf('day').format()
            }
            break
          case 'dealerIds':
            param[key] = this.data[key].map(
              (aid: number) => this.dealersStore.getDealer(aid)?.subjectId,
            )
            break
          case 'year':
            param['year'] = this.data[key]
            break
          case 'month':
            param['month'] = this.data[key]
            param['year']
              ? (param['year'] = param['year'])
              : (param['year'] = +moment().year())
            break
          case 'shelvs':
            if (!param['storageids']) {
              param['storageids'] = []
            }
            if (!this.data['boxes'].length) {
              param['storageids'].push(this.data[key])
            }
            break
          case 'boxes':
            if (!param['storageids']) {
              param['storageids'] = []
            }
            param['storageids'].push(...this.data[key])
            break
          default:
            param[key] = this.data[key]
            break
        }
      }
    }
    return param
  }
}

const serviceReportsFilterStore = new ServiceReportsFilterStore()

export default serviceReportsFilterStore
